<section class="layout__main-modal confirm-submit-dialog">
  <div
    mat-dialog-title
    class="dialog-title"
  >
    <button
      class="btn-close"
      type="button"
      mat-icon-button
      (click)="close()"
    >
      <mat-icon class="icon-close">close</mat-icon>
    </button>
    <img
      class="dialog-title__icon"
      src="../../../../assets/images/icons/illustrations/document-submit.svg"
      alt=""
    />
    <span class="ext-tilte">Submit Document</span>
    <span class="text-des">Are you sure to submit the document ?</span>
  </div>
  <mat-dialog-content
    class="dialog-content"
    *ngIf="attachments.length"
  >
    <span
      class="text-des"
      style="margin-bottom: 8px"
      >Attached documents</span
    >
    <div
      class="attachment-item"
      *ngFor="let attachment of attachments"
    >
      <div class="attachment-item__cell">
        <div class="attachment-item__icon">
          <mat-icon svgIcon="document"></mat-icon>
        </div>
        <p class="m-0 text-truncate">
          <span class="text-color-dark">{{ attachment.file?.name }}</span>
        </p>
        <span class="text-color-gray">{{ ' (' + (attachment.file?.size | fileSize) + ')' }}</span>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    <button mat-flat-button(click)="close()">Cancel</button>
    <button
      mat-button
      class="cimb-button--primary"
      (click)="submit()"
    >
      Submit
    </button>
  </mat-dialog-actions>
</section>
